import {axios} from '../Api';

export const TOOL_CHANGE = 'TOOL_CHANGE';

export const onToolChanged = (tool, shape = null, reverse = false) => {
    return {
        type: TOOL_CHANGE,
        tool,
        shape,
        reverse,
    }
};

export const LASSO_CYCLE = 'LASSO_CYCLE';

export const onLassoCycle = (backward = false) => {
    return {
        type: LASSO_CYCLE,
        backward,
    }
};

export const BRUSH_SIZE_CHANGE = 'BRUSH_SIZE_CHANGE';

export const onBrushSizeChange = (value) => {
    return {
        type: BRUSH_SIZE_CHANGE,
        value,
    };
};

export const BRUSH_CYCLE = 'BRUSH_CYCLE';

export const onBrushCycle = (backward = false) => {
    return {
        type: BRUSH_CYCLE,
        backward,
    }
};

export const ERASE_BOOST_LEVEL_CHANGE = 'ERASE_BOOST_LEVEL_CHANGE';

export const onEraseBoostLevelChange = (value) => {
    return {
        type: ERASE_BOOST_LEVEL_CHANGE,
        value,
    };
};

export const MARK_EDIT_REQUEST = 'MARK_EDIT_REQUEST';
export const MARK_EDIT_SUCCESS = 'MARK_EDIT_SUCCESS';
export const MARK_EDIT_FAILURE = 'MARK_EDIT_FAILURE';

export const markEdit = (type, amplitude, spread, id, editHistory) => async (dispatch) => {
    dispatch({type: MARK_EDIT_REQUEST});
    const edits = editHistory.map(editItem => editItem.uuid);
    try {
        await axios.put('/app/api/edits/mark', {edits, amplitude, spread, imageId: id, type});
        return dispatch({type: MARK_EDIT_SUCCESS});
    } catch (error) {
        console.error(error);
        return dispatch({type: MARK_EDIT_FAILURE, error});
    }
};




// WEBPACK FOOTER //
// ./src/actions/ControlPanelActions.js